import firebase from "firebase";
import store from "@/store";

let auth = null;

/**
 * @function getIdToken
 * @description Get the Firebase authentication token.
 * @param {Object} [options] - Options to pass to the function.
 * @param {boolean} [options.forceLoad=false] - If true, the token will be reloaded from the server.
 * @returns {Promise<string | null>} - Resolves with the Firebase authentication token or null if there is no user logged in.
 * @throws {Error} - If there is an error while getting the token, it will be thrown.
 */
async function getIdToken(options = {}) {
  try {
    const cachedToken = store.state.firebaseToken;
    const expirationTime = new Date(store.state.firebaseTokenExpirationTime).getTime();
    const tokenExpired = expirationTime < Date.now();
    
    if (!options.forceLoad && !tokenExpired && cachedToken) {
      return cachedToken;
    }
    
    auth = auth ?? firebase.auth();
    
    const tokenData = await auth.currentUser?.getIdTokenResult();
    
    if (!tokenData) {
      store.commit("SET_FIREBASE_TOKEN", { token: null, expirationTime: null });
      return null;
    }
    
    store.commit("SET_FIREBASE_TOKEN", { token: tokenData.token, expirationTime: tokenData.expirationTime });
    
    return tokenData.token;
  } catch (error) {
    store.commit("SET_FIREBASE_TOKEN", { token: null, expirationTime: null });
    
    if (error.code === "auth/timeout") {
      // Handle the timeout error...
      await store.dispatch("showAlertSnackBar", { text: "Your session has expired. Please try logging in again." });
    } else {
      // Handle other errors
      // await store.dispatch("showAlertSnackBar", {text: 'Something went wrong. Please try again'})
    }
    
    throw error;
  }
}

export default getIdToken;
